import { Switch } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { theme } from "@Styled";

export const useStyles = (isBrandingLocked: boolean) => {
    const theme = useTheme();

    return {
        root: {
            flexGrow: 1,
        },
        gridContainer: {
            justifyContent: "space-between",
            alignItems: "flex-end",
            position: "relative",
        },
        settingRow: {
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
        },
        customSection: {
            marginTop: theme.spacing(2),
        },
        customRow: {
            display: "flex",
            alignItems: "flex-start",
            flexWrap: "nowrap",
            columnGap: theme.spacing(2),
            "&:not(:last-child)": {
                marginBottom: theme.spacing(2),
            },
        },
        labelField: {
            flex: "0 0 220px",
            maxWidth: 220,
            width: 220,
            "& .MuiFormControl-root": {
                width: "100%",
            },
            "& .MuiOutlinedInput-root": {
                alignItems: "center",
                paddingTop: theme.spacing(1.25),
                paddingBottom: theme.spacing(1.25),
                minHeight: 56,
            },
            "& .MuiOutlinedInput-inputMultiline": {
                padding: theme.spacing(0.5, 1.5, 0.5, 1.5),
            },
            "& textarea": {
                overflow: "hidden",
            },
            "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
                transform: "translate(14px, 18px) scale(1)",
            },
        },
        optionsField: {
            flex: "0 0 460px",
            maxWidth: 460,
            width: 460,
            "& .MuiFormControl-root": {
                width: "100%",
            },
            "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
                paddingTop: theme.spacing(1.25),
                paddingBottom: theme.spacing(1.25),
                minHeight: 56,
            },
            "& .MuiOutlinedInput-inputMultiline": {
                padding: theme.spacing(0.5, 1.5, 0.5, 1.5),
            },
            "& .MuiAutocomplete-inputRoot": {
                flexWrap: "wrap",
                alignItems: "flex-start",
            },
            "& .MuiAutocomplete-endAdornment": {
                top: theme.spacing(1.5),
            },
            "& .MuiAutocomplete-tag": {
                marginTop: theme.spacing(0.5),
                marginRight: theme.spacing(0.5),
            },
            "& .MuiFormHelperText-root": {
                marginLeft: 0,
                marginRight: 0,
            },
        },
        removeButton: {
            marginTop: theme.spacing(1),
            flex: "0 0 auto",
            alignSelf: "flex-start",
            position: "relative",
            right: theme.spacing(1.5),
        },
        chip: {
            marginRight: theme.spacing(0.5),
            marginBottom: theme.spacing(0.5),
        },
        qrColorText: {
            color: isBrandingLocked ? theme.palette.grey[500] : "initial",
            [theme.breakpoints.down(332)]: {
                marginBottom: "12px",
            },
        },
        colorWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            [theme.breakpoints.down(332)]: {
                width: "100%",
            },
        },
        picker: {
            marginRight: "10px",
            cursor: isBrandingLocked ? "not-allowed" : "pointer",
            "& >div": {
                maxWidth: "120px",
            },
            "& [data-testid='colorpicker-button']": {
                marginBottom: 0,
                pointerEvents: isBrandingLocked ? "none" : "unset",
            },
            "& [data-testid='colorpicker-noinput']": {
                alignSelf: "flex-end",
                borderBottom: "1px solid rgba(0,0,0,0.87)",
                padding: "6px 0 7px",
                cursor: isBrandingLocked ? "not-allowed" : "pointer",
                pointerEvents: isBrandingLocked ? "none" : "unset",
            },
        },
        qrCode: {
            zoom: "0.35",
        },
    };
};

export const PurpleSwitch = styled(Switch)(() => ({
    "& .MuiSwitch-switchBase": {
        color: "#606060",
        "&.Mui-checked": {
            color: theme.palette.common.deepSkyBlue,
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: theme.palette.common.deepSkyBlue,
        },
    },
}));

export type ChannelSettingsDialogStyles = ReturnType<typeof useStyles>;
